import api from '@/utils/api';

const state = {
  companies: [],
  currentCompany: null,
  loading: false,
  error: null
};

const getters = {
  allCompanies: state => state.companies,
  currentCompany: state => state.currentCompany,
  isLoading: state => state.loading,
  hasError: state => state.error !== null,
  getErrorMessage: state => state.error
};

const actions = {
  async fetchCompanies({ commit }) {
    try {
      commit('SET_LOADING', true);
      const response = await api.get('/api/companies/');
      
      // No need to transform the URLs here, we'll handle them in the components
      commit('SET_COMPANIES', response.data.results || response.data);
    } catch (error) {
      commit('SET_ERROR', error.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  async fetchCompany({ commit }, id) {
    try {
      commit('SET_LOADING', true);
      const response = await api.get(`/api/companies/${id}/`);
      commit('SET_CURRENT_COMPANY', response.data);
    } catch (error) {
      commit('SET_ERROR', error.message);
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const mutations = {
  SET_COMPANIES(state, companies) {
    state.companies = companies;
  },
  SET_CURRENT_COMPANY(state, company) {
    state.currentCompany = company;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}; 